import { createShellPreferencesStore } from '@jarvis/platform-ui';

export const useShellPreferencesStore = createShellPreferencesStore({
  storageKey: 'assistantui:shell-prefs'
});
